import { z } from 'zod';
import { AnalyticsFieldSearchSchema, AnalyticsFieldSearchResponseSchema } from './fields.js';
import { AnalyticsQuerySchema, AnalyticsQueryResponseSchema } from './query.js';
import { AnalyticsTimestampSchema } from './timestamp.js';
export const FlowAnalyticsFieldsRoute = {
    method: 'get',
    fullPath: '/analytics/flows/fields',
    summary: 'Find fields for flow analytics',
    description: 'Find dimensions, measures and filter-only fields by keyword. Returns field metadata, ' +
        'not execution records or payloads. Results may include fields unavailable to the caller.',
    tags: ['Analytics'],
    query: AnalyticsFieldSearchSchema,
    response: AnalyticsFieldSearchResponseSchema,
};
export const FlowAnalyticsQuerySchema = AnalyticsQuerySchema.extend({
    runCreatedRange: z
        .strictObject({
        start: AnalyticsTimestampSchema.or(z.iso.date()).describe('Inclusive run-creation instant. Date-only inputs mean midnight UTC.'),
        end: AnalyticsTimestampSchema.or(z.iso.date()).describe('Exclusive run-creation instant. Date-only inputs mean midnight UTC.'),
    })
        .refine((range) => Date.parse(range.start) < Date.parse(range.end), {
        message: 'Run-created range end must be after start',
        path: ['end'],
    })
        .describe('Limits the run-creation cohort independently of event-time filters. Results may omit events from older runs.'),
});
export const FlowAnalyticsQueryRoute = {
    method: 'post',
    fullPath: '/analytics/flows/query',
    summary: 'Query flow analytics',
    description: 'Analyze flow and block executions, run summaries, and exported outputs and errors. ' +
        'Supply runCreatedRange explicitly, and use field discovery to choose fields and event-time filters. ' +
        'Run-summary counts include subflows unless filtered, ' +
        'and exported outputs may be incomplete.',
    tags: ['Analytics'],
    capabilityTags: ['ResponseCouldIncludePhi'],
    body: FlowAnalyticsQuerySchema,
    response: AnalyticsQueryResponseSchema,
};
//# sourceMappingURL=flow.js.map